<template>
  <div id="app">
    <Navbar />
    <Hero />
    <CoreData />
    <Scenes />
    <Products />
    <TechAdvantage />
    <Solution />
    <About />
    <Carousel />
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Hero from './components/Hero.vue'
import CoreData from './components/CoreData.vue'
import Scenes from './components/Scenes.vue'
import Products from './components/Products.vue'
import TechAdvantage from './components/TechAdvantage.vue'
import Solution from './components/Solution.vue'
import About from './components/About.vue'
import Carousel from './components/Carousel.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Hero,
    CoreData,
    Scenes,
    Products,
    TechAdvantage,
    Solution,
    About,
    Carousel,
    Footer
  }
}
</script>

<style>
/* 全局响应式设置 */
html {
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: manipulation;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 移动端基础设置 */
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }

  * {
    -webkit-tap-highlight-color: transparent;
  }

  input, 
  button {
    font-size: 16px; /* 防止 iOS 自动缩放 */
  }
}

/* 平板设备优化 */
@media (min-width: 769px) and (max-width: 1024px) {
  html {
    font-size: 15px;
  }
}

/* 触摸设备交互优化 */
@media (hover: none) {
  .btn:active {
    transform: scale(0.98);
  }
}
</style>
